import { Trans } from '@mc/i18n'
import { getNumberOfInstructors } from '@mc/instructors'
import { ButtonSizes, ButtonSizeValue } from '@mc/design-system'

import { PricingText } from 'components/PricingText'
import { NON_PROMO_STICKY_FOOTER_REDESIGN_I18N_NAMESPACE } from 'experiments/pen-4734_v1-non-promo-sticky-footer-redesign/i18n'

import classes from './NonPromoStickyFooterRedesignVariant.module.scss'

interface NonPromoStickyFooterRedesignVariantProps {
  SignUpCta: React.ComponentType<{ size?: ButtonSizeValue }>
}

export const NonPromoStickyFooterRedesignVariant = ({
  SignUpCta,
}: NonPromoStickyFooterRedesignVariantProps) => (
  <div className='container mc-px-5 mc-py-2 mc-py-md-4'>
    <NonPromoStickyFooterRedesignVariantDesktop SignUpCta={SignUpCta} />
    <NonPromoStickyFooterRedesignVariantMobile SignUpCta={SignUpCta} />
  </div>
)

export const NonPromoStickyFooterRedesignVariantDesktop = ({
  SignUpCta,
}: NonPromoStickyFooterRedesignVariantProps) => (
  <div className='d-none d-sm-flex align-items-center justify-content-between'>
    <div
      className={`d-flex flex-wrap align-items-center ${classes.titleContainer}`}
    >
      <Title />
    </div>
    <div className='d-flex align-items-center mc-ml-2'>
      <span
        className={`mc-text-x-small mc-mr-2 mc-mr-md-4 ${classes.pricingText}`}
      >
        <PricingText translationKey='pen-4734_v1-nonPromoStickyFooterRedesign' />
      </span>
      <SignUpCta />
    </div>
  </div>
)

export const NonPromoStickyFooterRedesignVariantMobile = ({
  SignUpCta,
}: NonPromoStickyFooterRedesignVariantProps) => (
  <div className='d-flex d-sm-none row'>
    <div className='col-6 d-flex align-items-center'>
      <Title />
    </div>
    <div className='col-6 d-flex flex-column justify-content-between align-items-end mc-gap-2'>
      <SignUpCta size={ButtonSizes.SM} />
      <span className={`mc-font-caption mc-text--right ${classes.pricingText}`}>
        <PricingText translationKey='pen-4734_v1-nonPromoStickyFooterRedesign-mobile'>
          <p />
          <p />
        </PricingText>
      </span>
    </div>
  </div>
)

export const Title = () => (
  <h2
    className={`mc-text--brand mc-text--uppercase mc-mr-sm-6 ${classes.title}`}
  >
    <Trans
      i18nKey='stickyFooter.title'
      ns={NON_PROMO_STICKY_FOOTER_REDESIGN_I18N_NAMESPACE}
      values={{ numberOfClasses: getNumberOfInstructors() }}
    >
      <span className='mc-text-color--tertiary mc-mr-1' />
      <span className='mc-text-color--primary mc-mr-1' />
      <span className='mc-text-color--tertiary mc-mr-1' />
    </Trans>
  </h2>
)
